export const ONE_MONTH = "one_month_credit";
export const THREE_MONTH = "three_months_credit";
export const SIX_MONTH = "six_months_credit";
export const ONE_YEAR = "one_year_credit";

export const selectProMemberships = [
  {
    value: ONE_MONTH,
    label: "ELSA PRO 1 Month"
  },
  {
    value: THREE_MONTH,
    label: "ELSA PRO 3 Months"
  },
  {
    value: SIX_MONTH,
    label: "ELSA PRO 6 Months"
  },
  {
    value: ONE_YEAR,
    label: "ELSA PRO 1 Year"
  }
]

export const selectELSAPremiumMemberships = [
  {
    value: ONE_MONTH,
    label: "ELSA PREMIUM 1 Month"
  },
  {
    value: THREE_MONTH,
    label: "ELSA PREMIUM 3 Months"
  },
  {
    value: SIX_MONTH,
    label: "ELSA PREMIUM 6 Months"
  },
  {
    value: ONE_YEAR,
    label: "ELSA PREMIUM 1 Year"
  }
]

export const selectEIKENMemberships = [
  {
    value: ONE_MONTH,
    label: "EIKEN 1 Month"
  },
  {
    value: THREE_MONTH,
    label: "EIKEN 3 Months"
  },
  {
    value: SIX_MONTH,
    label: "EIKEN 6 Months"
  },
  {
    value: ONE_YEAR,
    label: "EIKEN 1 Year"
  }
]
